import React, { useState, useEffect } from 'react'
import Kavishwa from '../../assets/Kavishwa_Pic.png'
import GitHub from '../../assets/github 1.png'
import Facebook from '../../assets/2.png'
import LinkedIn from '../../assets/1.png'
import Instagram from '../../assets/3.png'
import Target from '../../assets/Target.png'

import './aboutme.css';

const Aboutus = () => {
    return (
        <>
            <div className='h-[30vmin] bg-white'>
                <div className='inner_white grid grid-cols-6 h-full '>
                    <div className='col-start-1 col-end-1 flex flex-col items-center self-center justify-self-center'>
                        <img src={Kavishwa} alt="" className='w-[15vmin]' />
                        <a href='https://github.com/kvshw' target='_blank'><img src={GitHub} className='w-[4vmin] mt-[2vmin]' alt="" /></a>
                    </div>
                    <div className='col-start-2 col-end-6 flex flex-col items-center self-center justify-self-center'>
                        <p>Hello, I'm Kavishwa, a passionate full stack developer with a love for creating innovative and user-centric web applications. With a strong foundation in both front-end and back-end technologies, I strive to craft seamless and engaging digital experiences.</p>
                        <div className='flex gap-4'>
                            <a href='https://www.linkedin.com/in/kavishwa-wendakoon/' target='_blank'><img src={LinkedIn} className='w-[4vmin] mt-[2vmin]' alt="" /></a>
                            <a href='https://www.facebook.com/kavishwa.bhashitha/' target='_blank'><img src={Facebook} className='w-[4vmin] mt-[2vmin]' alt="" /></a>
                            <a href='https://www.linkedin.com/in/kavishwa-wendakoon/' target='_blank'><img src={Instagram} className='w-[4vmin] mt-[2vmin]' alt="" /></a>
                        </div>
                    </div>
                    <div className='col-start-6 col-end-7 self-center justify-self-center'>
                        <img src={Target} alt="" className='w-[15vmin]' />
                    </div>

                </div>
            </div>
        </>
    )
}

export default Aboutus